import React from 'react'
import { useParams, Link } from 'react-router-dom'
import Footer from '../../components/common/Footer'
import { 
  BookOpen, 
  Target, 
  Clock, 
  Users, 
  ArrowRight,
  ChevronLeft,
  Star,
  TrendingUp
} from 'lucide-react'

const ChonLop: React.FC = () => {
  const { idLop } = useParams<{ idLop: string }>()
  
  const lopData = {
    '10': {
      title: 'Lớp 10',
      description: 'Cơ học - Newton',
      color: 'from-sky-50 to-sky-100',
      bgColor: 'from-blue-50 to-blue-100',
      chapters: [
        {
          id: '0',
          title: 'Chương 0: Mở đầu',
          description: 'Giới thiệu mục đích học tập môn Vật Lý',
          lessons: 1,
          time: 45,
          icon: '🌟'
        },
        {
          id: '1',
          title: 'Chương 1: Động học',
          description: 'Nghiên cứu chuyển động của các vật',
          lessons: 7,
          time: 315,
          icon: '🏃'
        },
        {
          id: '2',
          title: 'Chương 2: Động lực học',
          description: 'Nghiên cứu nguyên nhân gây ra chuyển động',
          lessons: 5,
          time: 225,
          icon: '⚡'
        },
        {
          id: '3',
          title: 'Chương 3: Năng lượng và Công',
          description: 'Nghiên cứu các dạng năng lượng và sự chuyển hóa',
          lessons: 5,
          time: 225,
          icon: '🔋'
        },
        {
          id: '4',
          title: 'Chương 4: Chuyển động tròn và Biến dạng',
          description: 'Nghiên cứu chuyển động tròn và biến dạng của vật rắn',
          lessons: 3,
          time: 135,
          icon: '🔄'
        }
      ]
    },
    '11': {
      title: 'Lớp 11',
      description: 'Dòng điện - Ampère',
      color: 'from-emerald-50 to-emerald-100',
      bgColor: 'from-green-50 to-green-100',
      chapters: [
        {
          id: '1',
          title: 'Chương 1: Dao động',
          description: 'Nghiên cứu dao động điều hòa và các loại dao động',
          lessons: 4,
          time: 180,
          icon: '📊'
        },
        {
          id: '2',
          title: 'Chương 2: Sóng',
          description: 'Nghiên cứu sóng cơ và sóng điện từ',
          lessons: 6,
          time: 270,
          icon: '🌊'
        },
        {
          id: '3',
          title: 'Chương 3: Điện trường',
          description: 'Nghiên cứu điện tích và điện trường',
          lessons: 3,
          time: 135,
          icon: '⚡'
        },
        {
          id: '4',
          title: 'Chương 4: Dòng điện và Mạch điện',
          description: 'Nghiên cứu dòng điện và các mạch điện cơ bản',
          lessons: 5,
          time: 225,
          icon: '🔌'
        }
      ]
    },
    '12': {
      title: 'Lớp 12',
      description: 'Điện từ trường - Faraday',
      color: 'from-violet-50 to-violet-100',
      bgColor: 'from-purple-50 to-purple-100',
      chapters: [
        {
          id: '1',
          title: 'Chương 1: Vật Lý nhiệt',
          description: 'Nghiên cứu nhiệt động lực học và chuyển pha',
          lessons: 6,
          time: 270,
          icon: '🌡️'
        },
        {
          id: '2',
          title: 'Chương 2: Khí lí tưởng',
          description: 'Nghiên cứu các định luật của khí lí tưởng',
          lessons: 5,
          time: 225,
          icon: '💨'
        },
        {
          id: '3',
          title: 'Chương 3: Từ trường',
          description: 'Nghiên cứu từ trường và cảm ứng điện từ',
          lessons: 5,
          time: 225,
          icon: '🧲'
        },
        {
          id: '4',
          title: 'Chương 4: Vật Lý hạt nhân',
          description: 'Nghiên cứu cấu trúc hạt nhân và phóng xạ',
          lessons: 5,
          time: 225,
          icon: '☢️'
        }
      ]
    }
  }

  const currentLop = lopData[idLop as keyof typeof lopData]
  
  if (!currentLop) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-slate-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-slate-700 mb-4">❌ Lớp không tồn tại</h1>
          <p className="text-xl text-gray-600 mb-8">Lớp {idLop} không có trong chương trình</p>
          <Link 
            to="/" 
            className="btn-primary inline-flex items-center px-6 py-3 rounded-lg"
          >
            ← Về trang chủ
          </Link>
        </div>
      </div>
    )
  }

  const totalLessons = currentLop.chapters.reduce((sum, chapter) => sum + chapter.lessons, 0)
  const totalTime = currentLop.chapters.reduce((sum, chapter) => sum + chapter.time, 0)

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-slate-50">
      {/* Header */}
      <div className={`bg-gradient-to-r ${currentLop.bgColor} py-16`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <Link 
              to="/" 
              className="inline-flex items-center text-slate-700 hover:text-slate-700 mb-6 transition-colors"
            >
              <ChevronLeft className="w-5 h-5 mr-2" />
              Về trang chủ
            </Link>
            
            <h1 className="text-5xl md:text-6xl font-bold text-slate-700 mb-6">
              {currentLop.title}
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
              {currentLop.description}
            </p>
            
            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl mx-auto">
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="text-3xl mb-2">📚</div>
                <div className="text-2xl font-bold text-slate-700">{totalLessons}</div>
                <div className="text-gray-600">Bài học</div>
              </div>
              
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="text-3xl mb-2">⏱️</div>
                <div className="text-2xl font-bold text-slate-700">{totalTime}</div>
                <div className="text-gray-600">Phút</div>
              </div>
              
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 text-center">
                <div className="text-3xl mb-2">🎯</div>
                <div className="text-2xl font-bold text-slate-700">{currentLop.chapters.length}</div>
                <div className="text-gray-600">Chương</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chapters Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-700 mb-4">
            📖 Chọn chương để bắt đầu học
          </h2>
          <p className="text-lg text-gray-600">
            Mỗi chương sẽ cung cấp kiến thức từ cơ bản đến nâng cao
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {currentLop.chapters.map((chapter) => (
            <div 
              key={chapter.id}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
            >
              {/* Chapter Header */}
              <div className={`bg-gradient-to-r ${currentLop.color} p-6 text-slate-800`}>
                <div className="text-4xl mb-3">{chapter.icon}</div>
                <h3 className="text-xl font-bold mb-2">{chapter.title}</h3>
                <p className="text-gray-600 text-sm opacity-90">{chapter.description}</p>
              </div>
              
              {/* Chapter Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                      <BookOpen className="w-4 h-4" />
                      <span>{chapter.lessons} bài</span>
                    </div>
                    
                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                      <Clock className="w-4 h-4" />
                      <span>{chapter.time} phút</span>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-1">
                    <Star className="w-4 h-4 text-yellow-500 fill-current" />
                    <span className="text-sm text-gray-600">4.8</span>
                  </div>
                </div>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    <span>Kiến thức cơ bản</span>
                  </div>
                  
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                    <span>Bài tập thực hành</span>
                  </div>
                  
                  <div className="flex items-center space-x-2 text-sm text-gray-600">
                    <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                    <span>Trắc nghiệm</span>
                  </div>
                </div>
                
                <Link
                  to={`/lop/${idLop}/chuong/${chapter.id}`}
                  className="btn-primary group w-full inline-flex items-center justify-center px-6 py-3 font-semibold rounded-xl"
                >
                  Bắt đầu học
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default ChonLop
